import { render, staticRenderFns, recyclableRender, components } from "./order-detail.vue?vue&type=template&id=104df154&scoped=true&"
var renderjs
import script from "./order-detail.vue?vue&type=script&lang=js&"
export * from "./order-detail.vue?vue&type=script&lang=js&"
import style0 from "./order-detail.vue?vue&type=style&index=0&id=104df154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104df154",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/my-course/order-detail.vue"
export default component.exports